import {createBrowserHistory} from 'history'
import {applyMiddleware, compose, createStore} from "redux";
import {routerMiddleware} from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import createRootReducer from "./reducers";
import rootSaga from './sagas'

export const history = createBrowserHistory();

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(
    applyMiddleware(
        routerMiddleware(history),
        sagaMiddleware,
        // ... other middlewares ...
    ),
    // other store enhancers if any
);

export default createStore(
    createRootReducer(history), // root reducer with router state
    enhancer);

// then run the saga
sagaMiddleware.run(rootSaga);
